/**
 * The in-memory access token (Story 17.2 — tokens are not readable by page
 * scripts).
 *
 * The ONE owner of the bearer the SPA sends. It lives in this module's closure
 * only — never `localStorage` / `sessionStorage` — so a script that reads web
 * storage finds no credential. The 30-day refresh token is not here at all: it
 * is an `HttpOnly` cookie the browser sends to `/api/auth/refresh` and
 * `/api/auth/logout` and page scripts cannot see.
 *
 * Consequence: a page load or a new tab starts with no token. `AuthContext`
 * obtains one on mount through `refreshOnce` (the cookie authenticates that
 * call); peer tabs share a rotated token over the `amatis-auth`
 * BroadcastChannel (`authChannel.ts`).
 *
 * Every former `localStorage.getItem('access_token')` reads `getAccessToken()`.
 */

let accessToken: string | null = null;

/** The current bearer, or `null` when this tab holds none. */
export function getAccessToken(): string | null {
  return accessToken;
}

/** Replace the bearer. A blank / non-string value is stored as `null`. */
export function setAccessToken(token: string | null | undefined): void {
  accessToken = typeof token === 'string' && token.length > 0 ? token : null;
}

/** Forget the bearer (logout, terminal auth failure). */
export function clearAccessToken(): void {
  accessToken = null;
}
